// extracted by mini-css-extract-plugin
module.exports = {"sidebar-item-container":"SidebarItem_sidebar-item-container__1Drgm","sidebar-item-icon":"SidebarItem_sidebar-item-icon__15H2u","active":"SidebarItem_active__2JbYe"};